export default "__VITE_PUBLIC_ASSET__c51b27f2__"